/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, OnInit, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgForm} from '@angular/forms';
import {StateService} from '@uirouter/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {finalize} from 'rxjs';

import template from './signal-admin-resource-specify-id-modal.component.html';
import {ADMIN_RESOURCE_PAGE_IMPORTS} from './admin-resource-page-imports';
import {SignalAdminResourceModel} from './signal-admin-resource-api';
import {SignalAdminResourcePageState} from './signal-admin-resource-page-state';

@Component({
  standalone: true,
  imports: ADMIN_RESOURCE_PAGE_IMPORTS,
  selector: 'adn-signal-admin-resource-specify-id-modal',
  template
})
export class SignalAdminResourceSpecifyIdModalComponent implements OnInit {
  state: SignalAdminResourcePageState<SignalAdminResourceModel>;

  newId = '';
  readonly checking = signal(false);
  readonly duplicate = signal(false);
  readonly checkFailed = signal(false);

  private readonly stateService = inject(StateService);
  private readonly modalRef = inject(BsModalRef);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.newId = this.state?.model().id || '';
  }

  checkId(form: NgForm): void {
    if (form.invalid || !this.state || this.checking()) {
      return;
    }
    this.duplicate.set(false);
    this.checkFailed.set(false);
    this.checking.set(true);
    this.state.api.exists(this.newId).pipe(
      finalize(() => this.checking.set(false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (exists) => {
        if (exists) {
          this.duplicate.set(true);
          return;
        }
        this.state.updateId(this.newId);
        this.modalRef.hide();
        this.stateService.go(this.stateService.current.name, {id: this.newId, isNew: true}, {
          notify: false,
          reload: false,
          location: 'replace'
        });
      },
      error: () => this.checkFailed.set(true)
    });
  }

  dismiss(): void {
    this.modalRef.hide();
  }
}
